import { NgModule } from "@angular/core";
import {
  IdsShimmerModule,
  IdsMobileHeaderModule,
  IdsIconButtonModule,
  IdsIconModule,
  IdsAlertModule,
  IdsOverlayOriginModule,
  IdsMainButtonModule,
  IdsLoadingModule,
  IdsAccordionModule,
  IdsFormModule,
  IdsFormFieldModule,
  IdsFormSelectionModule,
  IdsLikertModule,
  IdsCheckboxModule,
  IdsRadioButtonModule,
  IdsMobileHeaderActionContentDirective,
  IdsMobileHeaderTitleContentDirective,
  IdsContextualButtonModule,
  IdsActionButtonModule,
  IdsListModule 
} from "@ids/angular";

@NgModule({
  imports: [
    IdsShimmerModule,
    IdsMobileHeaderModule,
    IdsIconButtonModule,
    IdsIconModule,
    IdsAlertModule,
    IdsOverlayOriginModule,
    IdsMainButtonModule,
    IdsLoadingModule,
    IdsAccordionModule,
    IdsFormModule,
    IdsFormFieldModule,
    IdsFormSelectionModule,
    IdsLikertModule,
    IdsCheckboxModule,
    IdsRadioButtonModule,
    IdsMobileHeaderActionContentDirective,
    IdsMobileHeaderTitleContentDirective,
    IdsContextualButtonModule,
    IdsActionButtonModule,
    IdsListModule
  ],
  exports: [
    IdsShimmerModule,
    IdsMobileHeaderModule,
    IdsIconButtonModule,
    IdsIconModule,
    IdsAlertModule,
    IdsOverlayOriginModule,
    IdsMainButtonModule,
    IdsLoadingModule,
    IdsAccordionModule,
    IdsFormModule,
    IdsFormFieldModule,
    IdsFormSelectionModule,
    IdsLikertModule,
    IdsCheckboxModule,
    IdsRadioButtonModule,
    IdsMobileHeaderActionContentDirective,
    IdsMobileHeaderTitleContentDirective,
    IdsContextualButtonModule,
    IdsActionButtonModule,
    IdsListModule
  ],
})
export class IdsModule {}
